<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-03 10:52:13
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-18 15:52:57
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\step.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%A
-->

<template>
    <div class='step-box'>
        <div class="step-content">
            <div class="step-title">上传证件信息 <span class="red">*</span></div>
            <div class="up-list">
                <UpImg :img="params.idCardFrontPic"
                    bgImg="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/IDFront.png" type="idCardFrontPic"
                    txt="身份证人像面" @upload="uploadImg" />
                <UpImg :img="params.idCardBackPic"
                    bgImg="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/IDback.png" type="idCardBackPic"
                    txt="身份证国徽面" @upload="uploadImg" />
                <UpImg :img="params.idCardHandheldPic"
                    bgImg="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/IDHand.png" type="idCardHandheldPic"
                    txt="手持身份证" @upload="uploadImg" />
            </div>
        </div>

        <div class="step-content" style="margin-top: 10px;">
            <div class="step-title">请确认证件信息</div>

            <van-form ref="paramsForm" label-width="100px" :show-error="false" error-message-align="right"
                validate-first>
                <van-field v-model="params.trueName" clearable name="trueName" label="身份证名称" placeholder="请输入"
                    :rules="rule.trueName" />
                <van-field clearable v-model="params.idCardNumber" name="idCardNumber" label="身份证编号" placeholder="请输入"
                    :rules="rule.idCardNumber" />

                <van-field readonly clickable v-model="params.idCardValidDateStart" name="idCardValidDateStart"
                    label="身份证有效期">
                    <template #input>
                        <div style="width: 100%;">
                            <div>
                                <div class="time-box">
                                    <div :class="['start-time', params.idCardValidDateStart ? '' : 'placeholder']"
                                        @click="selectTimeHandel(1)"> {{ params.idCardValidDateStart ?
                    params.idCardValidDateStart :
                    '选择开始时间' }} </div>
                                    至
                                    <div :class="['end-time', params.idCardValidDateEnd ? '' : 'placeholder']"
                                        @click="selectTimeHandel(2)">{{ params.idCardValidDateEnd ?
                    params.idCardValidDateEnd :
                    '选择结束时间' }}</div>
                                </div>
                            </div>
                            <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
                                <van-checkbox v-model="isLong" icon-size="18px" checked-color="#d32537"
                                    :disabled="isLongDisbled" @click="isLongChange"><span
                                        :class="['agreewith', isLong ? 'red' : '']">长期有效</span></van-checkbox>
                            </div>
                        </div>
                    </template>
                </van-field>
            </van-form>
        </div>

        <Footer @giveup="giveup" @confirm="confirm" :step="1" @back="goProstep" />

        <!-- 时间选择 -->
        <van-popup v-model="timeShow" position="bottom">
            <van-datetime-picker v-model="selectTime" type="date" @cancel="timeShow = false" @confirm="timeConfirm" />
        </van-popup>
    </div>
</template>

<script>
import UpImg from "./uploadImg.vue"
import Footer from "./footer.vue"
import { h5IdentifyUrl, merchIdCard } from "@/api/index"
import { Toast } from 'vant';
import { dateFormat } from "@/utils/core.js"
export default {
    name: 'Step02',
    components: {
        UpImg,
        Footer
    },
    props: {
        merchartInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    watch: {
        merchartInfo: {
            immediate: false,
            deep: true,
            handler(val) {
                this.params.keys.forEach(key => {
                    this.params[key] = val[key]
                });
            }
        }
    },
    data() {
        return {
            params: {
                idCardFrontPic: "", // 	身份证正面照
                idCardBackPic: "", // 身份证反面照
                idCardHandheldPic: "", // 	手持身份证图片
                trueName: "", // 身份证姓名
                idCardNumber: "", // 身份证号
                idCardValidDateStart: "", // 身份证起始时间
                idCardValidDateEnd: "", // 身份证到期时间
                registerId: "", // 进件 ID
            },
            rule: {
                trueName: [
                    { required: true, message: '请输入身份证名称' }
                ],
                idCardNumber: [
                    { required: true, message: '请输入身份证编号' }
                ],
                // idCardValidDateStart: [
                //     { required: true, message: '请选择身份证有效期' }
                // ]
            },
            timeShow: false,
            selectTime: "",
            selectType: 1,   // 1：开始时间， 2：到期时间

            isLong: false,
            isLongDisbled: false,  // 是否禁用长期选择
        };
    },
    created() {
        Object.keys(this.params).forEach(key => {
            this.params[key] = this.merchartInfo[key]
        });
        this.params.registerId = this.merchartInfo.id
        if (this.params.idCardValidDateEnd == "长期") {
            this.isLong = true
        } else {
            this.isLong = false
            this.isLongDisbled = true
        }
    },
    methods: {
        uploadImg(file) {
            Toast.clear()
            if (file.type == "idCardFrontPic") {
                Toast.loading({
                    message: '识别中...',
                    forbidClick: true,
                });
                // 身份证正面识别
                h5IdentifyUrl({ isFace: true, url: file.url }).then(res => {
                    if (res.code != 200) {
                        Toast.clear()
                        Toast(res.msg)
                        return
                    }
                    this.params[file.type] = file.url
                    this.params.trueName = res.data.name;
                    this.params.idCardNumber = res.data.num;
                    Toast.clear()
                })
            } else if (file.type == "idCardBackPic") {
                Toast.loading({
                    message: '识别中...',
                    forbidClick: true,
                });
                // 身份证反面识别
                h5IdentifyUrl({ isFace: false, url: file.url }).then(res => {
                    if (res.code != 200) {
                        Toast(res.msg)
                        return
                    }

                    const end = res.data.end_date;
                    const start = res.data.start_date;
                    Toast.clear()
                    if (start.length != 8 || (end.length != 8 && end != '长期')) {
                        Toast("身份证上传有误，请重新上传");
                        return
                    }
                    this.params[file.type] = file.url
                    this.params.idCardValidDateStart = res.data.start_date;
                    this.params.idCardValidDateEnd = res.data.end_date;

                    if (end == "长期") {
                        this.isLong = true
                        this.isLongDisbled = false
                    } else {
                        this.isLongDisbled = true
                        this.isLong = false
                    }
                })
            } else {
                this.params[file.type] = file.url
            }

        },

        // 选择时间
        timeConfirm(e) {
            const time = dateFormat(e, "yyyyMMdd");
            this.selectType == 1 ? this.$set(this.params, "idCardValidDateStart", time) : this.$set(this.params, "idCardValidDateEnd", time);
            // this.$set(this.params.idCardValidDateStart, time)
            this.timeShow = false;
        },

        // 点击证件日期
        selectTimeHandel(type) {
            this.selectType = type;
            this.timeShow = true;
        },

        // 上一步
        goProstep() {
            this.$emit("goProstep", { step: 1 })
        },

        // 下一步
        async confirm() {
            // 触发表单的校验
            let flag = true
            await this.$refs.paramsForm.validate().then(() => {
                // 判断 时间是已经选择
                if (!this.params.idCardValidDateStart || !this.params.idCardValidDateEnd) {
                    Toast("请选择证件有效期！")
                    return;
                }

                // 判断照片 是否已全部上传
                if (!this.params.idCardFrontPic) {
                    Toast("请上传身份证人像面照片！")
                    return;
                }
                if (!this.params.idCardBackPic) {
                    Toast("请上传身份证国徽面照片！")
                    return;
                }
                if (!this.params.idCardHandheldPic) {
                    Toast("请上传手持身份证照片！")
                    return;
                }

                // 校验表单是否有为空的内容
                if (!this.objIsNull(this.params)) {
                    Toast("请完整填写表单！")
                    return;
                }

                Toast.loading({
                    message: '提交中...',
                    forbidClick: true,
                    duration: "toast"
                });

                merchIdCard({ ...this.params, referKey: this.$store.state.referKey }).then(res => {
                    if (res.code != 200) {
                        Toast(res.msg)
                        return;
                    }
                    this.$emit("confirm", { data: res.data, step: 1 })
                })
            }).catch(e => {
                Toast(`${e[0].message}`);
                return
            });
        },

        goProstep(val) {
            this.$emit("goProstep", { step: val.step })
        },

        // 放弃注册
        giveup() {
            this.$emit("giveup")
        },

        // 长期checkbox 切换
        isLongChange(e) {
            if (this.isLongDisbled) return
            if (e) {
                this.params.idCardValidDateEnd = "长期"
            } else {
                this.params.idCardValidDateEnd = ""
            }
        }
    },
};
</script>

<style scoped lang="scss">
.up-list {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

::v-deep .van-cell {
    padding: 15px 10px 10px 5px;

    .van-field__control {
        text-align: right;
    }
}

.time-box {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .start-time,
    .end-time {
        flex: 1;
        text-align: center;

    }

    .placeholder {
        color: #CCCCCC;
        font-size: 14px;
    }
}

.red {
    color: #D32537;
}
</style>
